export default "__VITE_ASSET__B1jSAu6B__"